// We should really introduce the GraphQL client library we use in mobile
// in this project too. For now, we can have artisanal GraphQL queries.
import gql from 'graphql-tag';

export const onProviderDashboardSubscriptionGql = gql`
  subscription onProviderDashboard {
    onProviderDashboard
  }
`;

export const onlineForMyClientsSubscriptionGql = gql`
  subscription onlineForMyClients {
    onlineForMyClients
  }
`;

export const onlineForLiveCoachingSubscriptionGql = gql`
  subscription onlineForLiveCoaching {
    onlineForLiveCoaching
  }
`;
